import { useState, useEffect } from "react";
import { Box, Button, Container, SpaceBetween, Spinner } from "@cloudscape-design/components";
import { signIn, getCurrentUser } from "../auth/MidwayAuth";

export default function AuthWrapper({ children }) {
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCurrentUser().then(({ username, userId: uid, isSignedIn }) => {
      setUser(isSignedIn ? username : null);
      setUserId(uid);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Box textAlign="center" padding={{ top: "xxxl" }}>
        <Spinner size="large" />
      </Box>
    );
  }

  if (!user) {
    return (
      <Box textAlign="center" padding={{ top: "xxxl" }}>
        <Container>
          <SpaceBetween size="l" alignItems="center">
            <Box variant="h2">Sign in required</Box>
            <Box variant="p">Please sign in with Midway to access this tool.</Box>
            <Button variant="primary" onClick={signIn}>Sign in with Midway</Button>
          </SpaceBetween>
        </Container>
      </Box>
    );
  }

  return typeof children === "function"
    ? children({ userId, isSignedIn: true })
    : children;
}
